import { PageHeading } from '@/console/ui/PageHeading'
import { TABS } from '@/console/shell/tabs'
import { WarehouseWorkspace } from './WarehouseWorkspace'

const tab = TABS.find((t) => t.key === 'wh')!

/**
 * 창고 탭(LOGISPRD-15602) — 왼쪽 전 창고 목록(비활성 포함)에서 고른 창고를 오른쪽에서 활성 전환하고 typed policy 6종을 편집한다.
 * LES 대조·FC 등록(LOGISPRD-13890)은 이 탭의 후속 섹션이다.
 */
export const WarehouseTab = ({ onBusyChange }: { onBusyChange?: (busy: boolean) => void }): JSX.Element => (
  <>
    <PageHeading title={tab.heading} sub={tab.sub} />
    <WarehouseWorkspace onBusyChange={onBusyChange} />
  </>
)
